import React from 'react'

const SkillCard = ({card,index,color,onClick,noTilt,cardClass}) => {
  const circleStyle = { background: `${card.color ? card.color : "#FFFFFF24"}` };
  if (noTilt) circleStyle.transform = "rotate(0deg)";

  const imgStyle = { width: card?.width, height: card?.height };
  if (noTilt) {
    imgStyle.transform = "rotate(0deg)";
  } else if (card?.transform) {
    imgStyle.transform = card.transform;
  }

  return (
     <div key={index} onClick={onClick} style={onClick ? {cursor:'pointer'} : {}} className={`w-100 h-100`}>

                 <div className={`feature-card position-relative w-100 h-100 d-flex flex-column${noTilt ? " feature-card--no-tilt" : ""} ${cardClass ? cardClass : ""}`} style={{minHeight:card?.minHeight,"--hover-color":card.hoverColor,"--borderColor": card.borderColor,'--boxShadow': card.boxShadow}}>
                   <h3 style={{color:"#94C23C"}} className='feature-card-content-text FS16FW500 fw-600 mb-0'>{card?.greenTitle}</h3>
                   <div
                     className="icon-circle"
                     style={circleStyle}
                   >
                   {
                    card?.img && (
                     <img src={card?.img} alt='skill-area' style={imgStyle}/>
                    )
                   }
                   </div>

                     {/* ✅ Badge (only if exists) */}
                       {card.badge && (
                         <span className="mt-4" style={{color:'#E89D45'}}>
                           {"#"+card.badge}
                         </span>
                       )}
       
                   <h3 style={{color:color && color}} className='feature-card-content-text FS24FW500 fw-700'>{card.title}</h3>
       
                   <p style={{color:color && color}} className='feature-card-content-text FS16FW500 fw-500'>{card.text}</p>
       
                 </div>     
               </div>
  )
}

export default SkillCard
